import axios from "axios";
import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import history from "~/history";
import * as feeTypes from "~/store/fee/feeTypes";
import * as loginActions from "~/store/login/actions";
import { FEATURE_TYPES } from "~/utils/constants";
import { CHANGE_BOOKING_FLOW } from "../totalData/types";
import * as actions from "./featuresActions";
import * as api from "./featuresAPIs";
import * as types from "./featuresTypes";

function* requestAllFeatures() {
  try {
    yield put(actions.loadingAllFeatures());
    const partnerid = yield select(state => state.totalData.partnerId);
    const hospitalSelected = yield select(
      state => state.totalData.hospitalSelected
    );
    axios.defaults.headers.partnerid = partnerid;
    const response = yield call(api.requestAllFeatures);
    const { data } = response;

    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");

    // page home: ko auto chọn
    // check đã chọn bv hay chưa
    // lấy những feature is actived
    if (hospitalSelected !== null) {
      const availableFeature = data.filter(o => o.status);
      if (availableFeature.length === 1) {
        yield put({
          type: types.SELECT_FEATURE,
          payload: availableFeature[0].type
        });
      } else {
        history.push(`${partnerid}/chon-hinh-thuc-dat-kham`);
      }
    }
    yield put(actions.requestAllFeaturesSuccess(data));
  } catch (error) {
    yield put(actions.requestAllFeaturesFail(error));
  }
}

function* watcherRequestAllFeatures() {
  yield takeLatest(types.REQUEST_ALL_FEATURES, requestAllFeatures);
}

// SELECT FEATURE
function* requestSelectFeature({ payload }) {
  try {
    const IsAuthenticated = yield select(state => state.user.IsAuthenticated);

    if (payload.includes("booking")) {
      if (!IsAuthenticated) {
        yield put(loginActions.redirectToMedproId("/chon-ho-so"));
      }

      yield history.push("/chon-ho-so");
      // yield put({ type: GET_BOOKING_TREE });
      const flow = payload.split(".")[1];
      yield put({ type: CHANGE_BOOKING_FLOW, flow });
      // yield put({ type: ADD_SLOTID, slotId: uuid() });
    } else {
      switch (payload) {
        case FEATURE_TYPES.paymentFee: {
          history.push("/tim-ma-thanh-toan-vien-phi");
          break;
        }
        case FEATURE_TYPES.paymentFeeHistory: {
          if (!IsAuthenticated) {
            yield put(loginActions.redirectToMedproId());
          } else {
            yield put({ type: feeTypes.GET_HISTORY_PAYMENT });
          }
          break;
        }
        case FEATURE_TYPES.eInvoice: {
          yield history.push("/tra-cuu-hoa-don-dien-tu");
          break;
        }
        case FEATURE_TYPES.examResultSearch: {
          yield history.push("/tra-cuu-hoa-don-dien-tu");
          break;
        }
        case FEATURE_TYPES._eInvoice: {
          yield history.push("/tra-cuu-hoa-don-dien-tu");
          break;
        }
        default: {
          return "";
        }
      }
    }
  } catch (error) {
    console.log("error requestSelectFeature :>> ", error);
  }
}

function* watcherSelectFeature() {
  yield takeLatest(types.SELECT_FEATURE, requestSelectFeature);
}

export default function* root() {
  yield all([fork(watcherRequestAllFeatures), fork(watcherSelectFeature)]);
}
